(function($) {

    // functions 



    $(document).ready(function(){

        // document ready

        $(document).on('click', '.loadmore a' , function(e){
            /* avant load */
            e.preventDefault();
            var url = $(this).attr('href');
            $(this).parent().fadeOut('fast' , function(){
                $(this).remove();
            });
            $('#loading-screen').addClass('active');
            $.get( url, {} ,function(result){
                /* fin du load */
                var posts = $(result).find('#main-listing > .listing');
                window.history.pushState({}, '', url);
                $('#loading-screen').removeClass('active');
                $('#main-listing').append(posts);
            });
        });

    });
    
    
    })(jQuery);